import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageFilter, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { getPedidoDefault, PedidoDto } from '../../interface/pedido';
import { PedidoService } from '../../service/pedido.service';
import { FiltroPedidosBloqueadosLista } from '../filtro/filtro-lista-pedidos-bloqueados';
import { Cliente } from 'src/app/interface/cliente';
import { ClienteLookupService } from 'src/app/service/cliente-lookup-service';


@Component({
  selector: 'app-faturamento-pedido-venda-liberacao-por-regra',
  templateUrl: './faturamento-pedido-venda-liberacao-por-regra.component.html',
  styleUrl: './faturamento-pedido-venda-liberacao-por-regra.component.css'
})
export class FaturamentoPedidoVendaLiberacaoPorRegraComponent implements OnInit {

  pedidosBloqueados: Array<any> = [];
  pedidosBloqueadosFiltro: FiltroPedidosBloqueadosLista;

  pedidoSelecionado: PedidoDto = getPedidoDefault();

  advancedClienteFilters: Array<PoDynamicFormField>;
  columnsClienteFilters: Array<PoLookupColumn>;
  fieldFormaterClienteFilters: ((value: Cliente) => string);

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  constructor(
    private router: Router,
    private poStorageService: PoStorageService,
    private poNotificationService: PoNotificationService,
    private poDialogService: PoDialogService,
    private pedidoService: PedidoService,
    public clienteLookupService: ClienteLookupService,
  ) {
    this.pedidosBloqueadosFiltro = new FiltroPedidosBloqueadosLista(this.poStorageService);

    this.advancedClienteFilters = this.clienteLookupService.getAdvancedFilter();
    this.columnsClienteFilters = this.clienteLookupService.getColumnsFilter();
    this.fieldFormaterClienteFilters = this.clienteLookupService.getFieldFormater;
  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('listaTitulosModal', { static: true }) listaTitulosModal!: PoModalComponent;

  ngOnInit(): void {
    this.loadDados();
  }

  loadDados(): void {
    this.pedidosBloqueadosFiltro.setStorage();

    this.pedidoService.listaPedidosBloqueadosPorRegra(this.pedidosBloqueadosFiltro.dados).subscribe((lista) => {
      this.pedidosBloqueados = lista.items.map((item) => {
        return {...item, favorite: ['liberar']}
      });
    });
  }

  public readonly colunas: Array<PoTableColumn> = [
    {
      property: 'CC5BLQ',
      label: 'Status',
      type: 'label',
      width: '10%',
      labels: [
        { value: '1', color: 'color-01', label: 'Bloqueado por Regra' },
        { value: '2', color: 'color-08', label: 'Bloqueado por Verba' },
      ]
    },
    {property: 'CC5NUM'       , label: 'Pedido'       },
    {
      property: 'CC5TIPO',
      label: 'Tipo',
      type: 'label',
      width: '10%',
      labels: [
        { value: 'N', color: 'color-11', label: 'Normal' },
        { value: 'B', color: 'color-07', label: 'Utiliza Fornecedor' },
      ]
    },
    {property: 'CZACPROJET'   , label: 'Projetos'      },
    {property: 'CZACINTERVDESC', label: 'Intervenção'      },
    {property: 'NQTDPENDENTE' , label: 'Saldo'   , type: 'number', format: '1.5-5'      },
    {property: 'CC5CLIENTE'   , label: 'Cod Cliente'  },
    {property: 'CC5LOJACLI'   , label: 'Loja'         },
    {property: 'CA1NREDUZ'    , label: 'Cliente'      },
    {property: 'CC5GUARITA'   , label: 'Cód. Guarita' },
    {property: 'CGUARITADESC' , label: 'Guarita'      },
    {property: 'DC5EMISSAO'   , label: 'Emissão' , type: 'date'  , format: 'dd/MM/yyyy' },
    {
      property: 'favorite',
      label: '...',
      type: 'icon',
      width: '8%',
      icons: [
        {
          action: this.liberarPedido.bind(this),
          icon: 'po-icon-change',
          tooltip: 'Liberar',
          value: 'liberar',
        },
      ]
    },
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Pedido de Venda', action: this.goHome.bind(this) },
      { label: 'Liberação por Regra' }
    ]
  };

  goHome(): void {
    this.router.navigateByUrl('');
  }

  liberarPedido(pedido: PedidoDto): void {

    this.poDialogService.confirm({
      title: 'Liberar pedido',
      message: 'Deseja realizara a liberação desse pedido?',
      confirm: () =>{
        this.pedidoService.postLiberaPedidoRegraSemValid(pedido.CC5NUM).subscribe((ret) => {
          this.poNotificationService.success('Pedido liberado com sucesso');
          this.loadDados();
        });
      }
    })
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.loadDados();
    },
    label: 'Aplicar Filtros'
  };
  

  clienteSelecionado(row: Cliente): void {
    this.pedidosBloqueadosFiltro.dados.CC5CLIENTE = row.CA1COD;
    this.pedidosBloqueadosFiltro.dados.CC5LOJACLI = row.CA1LOJA;
  }

}

